import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0 }) => (
  <span className="block overflow-hidden pb-1">
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.95, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Kicker = ({ num, label }) => (
  <div className="mb-6 flex items-center gap-4">
    {num && (
      <span className="font-tech text-xs font-semibold tracking-[0.3em] text-cyan-400">
        {num}
      </span>
    )}
    <span className="h-px w-10 bg-cyan-400/40" />
    <span className="font-tech text-xs uppercase tracking-[0.3em] text-slate-400">
      {label}
    </span>
  </div>
);

export const Section = ({ id, band = false, children, className = "" }) => (
  <section id={id} className={`relative ${band ? "bg-[#0A111E]" : ""} ${className}`}>
    <div className="mx-auto w-full max-w-6xl px-6 py-20 sm:py-28">{children}</div>
  </section>
);
